export default __webpack_public_path__ + "static/media/Trust_970_90.195fe41f.gif";